import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { logPageView } from '@/services/firebase/analytics';

/**
 * Śledzi odsłony stron w aplikacji SPA — przy każdej zmianie ścieżki
 * wysyła zdarzenie page_view do Firebase Analytics (jeśli skonfigurowany).
 */
export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    void logPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);
}
